module.exports = function() {
  return new Worker(__webpack_public_path__ + "80baab78115c86090333.worker.js");
};